<template>
    <v-list-item
            @click="clicked">
        <v-list-item-avatar>
            <v-icon color="primary">mdi-file</v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
            <v-list-item-title :class="item.is_default ? 'font-weight-bold primary--text' : ''">{{ item.filename }}
            </v-list-item-title>

        </v-list-item-content>
        <v-list-item-action v-if="!item.is_default">
            <v-tooltip bottom>
                <template #activator="{ on }">
                    <v-btn @click.stop="$emit('delete', item)" icon ripple v-on="on">
                        <v-icon color="error">mdi-trash-can-outline</v-icon>
                    </v-btn>
                </template>
                <span>Datei löschen</span>
            </v-tooltip>
        </v-list-item-action>
    </v-list-item>
</template>
<script>
    export default {
        name: 'file-list-tile',
        props: {
            item: {}
        },
        computed: {},
        methods: {
            clicked() {
                this.$emit('click', this.item)
            }
        }
    }
</script>
